import { useAxios } from "../../../common/hooks/useProviderAxios";

const host = process.env.REACT_APP_API_ENDPOINT;

const commentProvider = () => {
  const { axios } = useAxios();

  const getComment = async (params) => {
    try {
      const url = `${host}/getReply${params}`;
      const res = await axios.get(url);
      return res.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };

  const addComment = async (body) => {
    try {
      const url = `${host}/replys/addReply`;
      const res = await axios.post(url, body);
      return res.data;
    } catch (error) {
      if (error.code === "ER_BAD_FIELD_ERROR") {
        throw error;
      }
      return error;
    }
  };

  const editComment = async (id, body) => {
    try {
      const url = `${host}/replys/${id}`;
      const res = await axios.patch(url, body);
      return res.data;
    } catch (error) {
      return error;
    }
  };

  const deleteComment = async (id) => {
    try {
      const url = `${host}/replys/${id}`;
      const res = await axios.delete(url);

      return res.data;
    } catch (error) {
      return error;
    }
  };

  return {
    getComment,
    addComment,
    editComment,
    deleteComment,
  };
};

export default commentProvider;
